/* Nomination hızlı sepet - Veritas Dijital */
(function () {
  'use strict';
  if (customElements.get('quick-cart')) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function jsonPost(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) return Promise.reject(data);
        return data;
      });
    });
  }

  class QuickCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') this.close();
      }.bind(this));

      var self = this;
      window.NmCart = this;

      /* Header sepet ikonu */
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-nm-cart-open]');
        if (!trigger) return;
        if (document.body.classList.contains('template-cart')) return;
        e.preventDefault();
        self.opener = trigger;
        self.open();
      });

      /* Diğer kodlar (ör. fbt.liquid) için olaylar */
      ['quick-cart:open', 'theme:cart:open', 'cart:open'].forEach(function (name) {
        document.addEventListener(name, function () { self.open(); });
      });
      document.addEventListener('cart:refresh', function () { self.refresh(); });
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      document.body.classList.add('nm-scroll-lock');
      var container = this.querySelector('.quick-cart__container');
      if (container) setTimeout(function () { container.focus(); }, 50);
    }

    close() {
      this.classList.remove('is-open', 'is-active', 'active', 'open');
      var wrapper = this.querySelector('.quick-cart__wrapper');
      if (wrapper) wrapper.classList.remove('is-open', 'is-active', 'active');
      document.body.classList.remove('nm-scroll-lock');
      if (this.opener) this.opener.focus();
    }

    renderSection(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.quick-cart__wrapper');
      var current = this.querySelector('.quick-cart__wrapper');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }

    updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
    }

    refresh() {
      var self = this;
      return fetch(root + '?sections=' + this.sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) { self.renderSection(data[self.sectionId]); })
        .then(function () { return fetch(root + 'cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.updateCount(cart.item_count); return cart; });
    }

    /* product-form.js tarafından çağrılır */
    afterAdd(response) {
      var self = this;
      var useConfirm = this.dataset.confirm === 'true';
      if (response && response.sections && response.sections[this.sectionId]) {
        this.renderSection(response.sections[this.sectionId]);
      }
      return fetch(root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.updateCount(cart.item_count);
          if (!(response && response.sections)) self.refresh();
          if (useConfirm && response && response.id) {
            self.showConfirm(response, cart);
          } else {
            self.open();
          }
        });
    }

    formatMoney(cents) {
      var format = this.dataset.moneyFormat || '{{amount}}';
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        if (key === 'amount_with_comma_separator') return withDot;
        if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return withComma;
      });
    }

    showConfirm(item, cart) {
      var box = document.querySelector('[data-nm-confirm]');
      if (!box) { this.open(); return; }
      var self = this;
      var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var threshold = parseInt(this.dataset.freeThreshold, 10);
      var shipping = '';
      if (threshold) {
        var remaining = threshold - cart.total_price;
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        var msg = remaining > 0 ? this.dataset.strRemaining.replace('[amount]', this.formatMoney(remaining)) : this.dataset.strFree;
        shipping = '<div class="qc-shipping nm-confirm__shipping"><div class="qc-shipping__msg"><p>' + msg + '</p></div><div class="qc-shipping__bar"><span style="width:' + pct + '%"></span></div></div>';
      }
      box.innerHTML =
        '<div class="nm-confirm__inner">' +
          '<p class="nm-confirm__heading">' + esc(this.dataset.strAdded) + '</p>' +
          '<div class="nm-confirm__item">' +
            (img ? '<img class="nm-confirm__img" src="' + esc(img) + '" alt="" width="120" height="120">' : '') +
            '<div><p class="nm-confirm__title">' + esc(item.product_title) + '</p>' +
            (variant ? '<p class="nm-confirm__variant">' + esc(variant) + '</p>' : '') +
            '<p class="nm-confirm__price">' + esc(this.formatMoney(item.final_line_price || item.price)) + '</p></div>' +
          '</div>' +
          '<a href="' + root + 'cart" class="nm-btn nm-btn--secondary nm-confirm__btn" data-nm-confirm-view>' + esc(this.dataset.strView.replace('[count]', cart.item_count)) + '</a>' +
          '<a href="' + root + 'checkout" class="nm-btn nm-btn--primary nm-confirm__btn">' + esc(this.dataset.strCheckout) + '</a>' +
          shipping +
        '</div>';
      var header = document.querySelector('nm-header');
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      box.style.top = top + 'px';
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-visible'); });
      var view = box.querySelector('[data-nm-confirm-view]');
      view.addEventListener('click', function (e) {
        e.preventDefault();
        self.hideConfirm();
        self.open();
      });
      clearTimeout(this.confirmTimer);
      this.confirmTimer = setTimeout(function () { self.hideConfirm(); }, 6000);
      if (!this.confirmBound) {
        this.confirmBound = true;
        document.addEventListener('click', function (e) {
          if (!box.hidden && !e.target.closest('[data-nm-confirm]')) self.hideConfirm();
        });
      }
    }

    hideConfirm() {
      var box = document.querySelector('[data-nm-confirm]');
      if (!box || box.hidden) return;
      box.classList.remove('is-visible');
      setTimeout(function () { box.hidden = true; }, 250);
    }

    changeLine(line, quantity, itemEl) {
      var self = this;
      this.classList.add('is-loading');
      return jsonPost('cart/change.js', {
        line: line,
        quantity: quantity,
        sections: [this.sectionId],
        sections_url: window.location.pathname
      })
        .then(function (cart) {
          self.renderSection(cart.sections && cart.sections[self.sectionId]);
          self.updateCount(cart.item_count);
        })
        .catch(function () {
          if (itemEl) {
            var err = itemEl.querySelector('.qc-item__error');
            if (err) err.hidden = false;
          }
          return self.refresh();
        })
        .finally(function () { self.classList.remove('is-loading'); });
    }

    onClick(e) {
      var target = e.target;
      if (target.closest('[data-qc-close]')) {
        e.preventDefault();
        this.close();
        return;
      }

      var qtyBtn = target.closest('[data-qc-qty]');
      if (qtyBtn) {
        var item = qtyBtn.closest('.qc-item');
        this.changeLine(parseInt(item.dataset.line, 10), parseInt(qtyBtn.dataset.qcQty, 10), item);
        return;
      }

      var addBtn = target.closest('[data-qc-add]');
      if (addBtn) {
        var self = this;
        addBtn.disabled = true;
        jsonPost('cart/add.js', { items: [{ id: parseInt(addBtn.dataset.qcAdd, 10), quantity: 1 }], sections: [this.sectionId] })
          .then(function (res) {
            self.renderSection(res.sections && res.sections[self.sectionId]);
            return fetch(root + 'cart.js').then(function (r) { return r.json(); });
          })
          .then(function (c) { self.updateCount(c.item_count); })
          .catch(function () { addBtn.disabled = false; });
        return;
      }

      var checkout = target.closest('[data-qc-checkout]');
      if (checkout) {
        checkout.disabled = true;
        var havale = checkout.dataset.qcCheckout === 'havale';
        jsonPost('cart/update.js', { attributes: { odeme_yontemi: havale ? 'havale' : '' } })
          .then(function () {
            window.location.href = havale ? root + 'checkout?discount=HAVALE5' : root + 'checkout';
          })
          .catch(function () { checkout.disabled = false; });
      }
    }

    onChange(e) {
      if (e.target.matches('[data-qc-input]')) {
        var item = e.target.closest('.qc-item');
        var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
        this.changeLine(parseInt(item.dataset.line, 10), qty, item);
      } else if (e.target.matches('[data-qc-note]')) {
        jsonPost('cart/update.js', { note: e.target.value }).catch(function () {});
      }
    }
  }

  customElements.define('quick-cart', QuickCart);
})();
